import { render, staticRenderFns } from "./ColorPickerButton.vue?vue&type=template&id=038c77fd"
import script from "./ColorPickerButton.vue?vue&type=script&lang=js"
export * from "./ColorPickerButton.vue?vue&type=script&lang=js"
import style0 from "./ColorPickerButton.vue?vue&type=style&index=0&id=038c77fd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports